export const validateTIN = (value: string) => {
  const isValid = /^[0-9]{9}$/.test(value)

  let error: string | null = null
  if (!isValid) error = 'Must have 9 numbers'

  if (error) return Promise.reject(new Error(error))
  else return Promise.resolve()
}
